import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';
import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';


@Component(
    {
        selector: 'colaborador',
        templateUrl: './colaborador.template.html',
        styleUrls: ['./colaborador.component.scss']
    })

export class ColaboradorComponent implements AfterViewInit {
    dataTable!: Array<any>;
    SelEstatusColaborador: any[];

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string
    masterRows: []

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService) {
        //super(props);
        this.masterRows = [];

        this.uriApi = "reporte/colaborador";
        this.SelEstatusColaborador = [];
        this.GenerarFiltros()
    }

    ngAfterViewInit() {
        this.setEstatusColaborador();
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Número de nómina',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nomina'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Nombre',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nombre'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Apellido paterno',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'apellidopaterno'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Apellido materno',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'apellidomaterno'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Fecha,
                    Titulo: 'Fecha nacimiento',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'fechanacimiento'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'RFC',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'rfc'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'CURP',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'curp'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Telefono celular',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'telefonocelular',
                    Mask: this.sistemaService.telefonoMask
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Email personal',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'emailpersonal'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Estatus',
                    DisplayValor: 'nombre',
                    ValorName: 'estatuscolaboradorid',
                    Opciones: this.SelEstatusColaborador,
                    Propiedad: "estatuscolaboradorid",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    setEstatusColaborador() {
        this.appService.Get("catalogo/estatuscolaborador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEstatusColaborador = res.data
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'estatuscolaboradorid');
                if (filtro) {
                    filtro.Opciones = this.SelEstatusColaborador;
                }
            }
        });
    }


    SetDatos(data: any) {
        this.dataTable = data;
    }


    onExporting(e: any) {
        //e.cancel = true;
    }

}
